import { render } from "./InsumosStock.vue?vue&type=template&id=5fd5abb4&scoped=true"
import script from "./InsumosStock.vue?vue&type=script&lang=js"
export * from "./InsumosStock.vue?vue&type=script&lang=js"

import "./InsumosStock.vue?vue&type=style&index=0&id=5fd5abb4&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd5abb4"]])

export default __exports__